export default __webpack_public_path__ + "static/media/Aprende JSON - Linkedin.3f9334e0.png";